import React from 'react';
import spinner from '../Images/LINE_spinner_dark.svg';

function Loading() {
  return (
    <div className="loading">
      <img className="spinner" alt="読み込み中..." src={spinner} />
    </div>
  );
}

export default Loading;